import { LocalStorageDataModel } from "../../constants/local-storage-data-model"
import {
  Env,
  getDataFromLocalStorage,
  setDataOnLocalStorage,
} from "../../utils/globalUtilities";
import axios from "axios";
const unauthorizedCode = [401];

export const RedisBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_REDIS_URL,
});

RedisBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("TaxmannAuthorization");
    let machineid = localStorage.getItem(LocalStorageDataModel.MACHINE_ID_NEW);

    config.headers = {
      refreshtoken: sessionStorage.getItem("refreshToken") || "",
      [LocalStorageDataModel.MACHINE_ID]: machineid,
    };

    if (token) {
      config.headers = {
        ...config.headers,
        taxmannauthorization: token,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

RedisBaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && unauthorizedCode.includes(response.status)) {
      // logoutUserSession()
    }
    return Promise.reject(error);
  }
);
